import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import { useState, useMemo} from "preact/hooks";
import { facetConfigs } from "../config"

import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import NestedCategories from "./NestedCategories";

export default function SideBar({ sidebarOpen, setSidebarOpen }) {
    const { facets } = useFacets();
    const { filters, removeAll } = useProductFilters();
    const [ activeFacet, setActiveFacet ] = useState(null);

    const fullNestedFacet = useMemo(() => facets.find(facet => facetConfigs[facet.id]?.nested && facetConfigs[facet.id]?.isFullValue), [ facets, facetConfigs ]);
    const splitNestedFacet = useMemo(() => facets.find(facet => facetConfigs[facet.id]?.nested && !facetConfigs[facet.id]?.isFullValue), [ facets, facetConfigs ]);

    const handleFacetToggle = (facetId) => {
        setActiveFacet(prev => (prev === facetId ? null : facetId));
    }

    return (
        <div class="ns-sidebar-wrapper">
            <div class="ns-filters-toggle-wrap">
                <button 
                    class="ns-filters-toggle ns-w-100 ns-flex ns-items-center ns-justify-center ns-flex-nowrap"
                    type="button"
                    aria-haspopup="dialog"
                    aria-controls="ns-sidebar"
                    aria-expanded={sidebarOpen}
                    aria-label={sidebarOpen ? 'Collapse filters' : 'Expand filters'}
                    onClick={() => setSidebarOpen(prev => !prev)}
                >
                    <span class="ns-filters-toggle-text">FILTERS</span>
                    <svg class="ns-chevron" role="presentation" aria-hidden="true" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 5.5C0.5 5.5 3.37324 0.5 3.45775 0.5C3.62676 0.5 6.5 5.5 6.5 5.5H0.5Z" fill="black"/>
                    </svg>
                    <span 
                        class="ns-close-icon ns-absolute"
                        role="presentation"
                        aria-hidden="true"
                    />
                </button>
            </div>

            <div 
                class="ns-sidebar ns-flex ns-flex-col"
                role="dialog"
                aria-modal="true"
                aria-labelledby="ns-sidebar-heading"
                tabIndex={-1}
            >
                <header>
                    <h2 id="ns-sidebar-heading" class="sr-only">
                        Filters
                    </h2>
                </header>
                <main class="ns-sidebar-body ns-relative ns-h-100 ns-custom-scrollbar">
                    <ul class="ns-facet-list ns-list-unstyled">
                        {(fullNestedFacet && splitNestedFacet) && (
                            <NestedCategories
                                key={splitNestedFacet.id}
                                fullNestedFacet={fullNestedFacet}
                                splitNestedFacet={splitNestedFacet}
                                activeFacet={activeFacet}
                                handleFacetToggle={handleFacetToggle}
                            />
                        )}
                        {facets?.map(facet => {
                            if(facetConfigs?.[facet.id]?.hidden) return null;

                            switch (facet.type) {
                                case "terms":
                                    return <Facet 
                                                key={facet.id} 
                                                facet={facet}
                                                activeFacet={activeFacet}
                                                handleFacetToggle={handleFacetToggle}
                                            />
                                case "stats":
                                    return <RangeFacet
                                                key={facet.id} 
                                                facet={facet} 
                                                activeFacet={activeFacet}
                                                handleFacetToggle={handleFacetToggle}
                                            />
                                default:
                                    return null
                            }
                        })}
                    </ul>
                </main>
                <footer class="ns-sidebar-footer ns-flex ns-flex-col ns-items-center ns-justify-center ns-w-100">
                    <button 
                        class="ns-apply-filters ns-block ns-w-100 ns-lg-hidden"
                        type="button"
                        onClick={() => setSidebarOpen(false)}
                    >
                        Apply Filters
                    </button>
                    <button
                        class="ns-clear-filters ns-block ns-w-100 ns-mt-2"
                        type="button"
                        disabled={filters.length < 1}
                        onClick={removeAll}
                    >
                        Clear Filters
                    </button>

                </footer>
            </div>
        </div>
    )
}
